import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import {init, refreshToken} from '../../auth/handleTokens';
import useAuth from '../../auth/useAuth';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';

const FreeMessage = (props) => {

    const toggle = props.toggleSidebar ? '215px' : '10px';
    const [autosend, setAutosend] = useState(false);
    const [message, setMessage] = useState('Mensaje de prueba');
    const [personalMessage, setPersonalMessage] = useState('');
    const [phone, setPhone] = useState('');
    const [anotherPhone, setAnotherPhone] = useState('');
    const [numFreeCredits, setFreeCredits] = useState();
    const {user} = useAuth();
    const {showNotification} = useContext(NotificationContext);
    const [update, setUpdate] = useState(false);
    

    const getMessage = async() => {
      try {
        const result = await init();
        if(!result) return window.location.href = '/login'
        const token= window.localStorage.getItem('at');
        const URL = constants.test_host + '/sms/freemessage/default'
        const {data} = await axios.get(URL, {headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'Application/json'
          
        }, withCredentials: true})
        setMessage(data.message[0] + user.organization);
        setPhone(data.phone);
        setFreeCredits(data.numFreeCredits);
        
      } catch (error) {
        if(error.response.data.statusCode === 401){
          const result = await refreshToken();
          if(result) getMessage();
          else return window.location.href= '/login';
        }else{
          return window.location.href= '/login';
        }
      }
    }

    const autoSend = () => {
      setAutosend(true);
      if(personalMessage === '' || personalMessage.trim().length <1){
        showNotification('failed', 'El campo del mensaje no puede estar vacío.')
        return
      }
      if(personalMessage.length > 159){
        showNotification('failed', 'El campo no puede contener más de 159 caracteres.');
        return
      }
      sendMessage();
    }

    const NoAutoSend = () => {
      setAutosend(false);
      sendMessage();
    }

    const sendMessage = async() => {
  
      try {
        const result = await init();
        if(!result) return window.location.href = '/login'
        const token = window.localStorage.getItem('at')
        const URL = constants.test_host + '/sms/autosend-freemessage';
        const {data} = await axios.post(URL,{phone, anotherPhone, personalMessage, message, autosend}, {headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'Application/json'
        }, withCredentials: true})
        if(data.result){ 
          showNotification('success', 'Mensaje enviado correctamente...')
          setFreeCredits(data.numFreeCredits);
          setUpdate(!update);
          setPersonalMessage('');
        }
      } catch (error) {
        showNotification('failed', error.response.data.message)
      }

    }

    useEffect(() => {
      getMessage();
    }, [update])

  return (
    <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }} >
        <h4>Bienvenido/a, {user.name}</h4>
        <p>Tienes {numFreeCredits} mensajes gratis de prueba, el primero se enviará a tu número de celular: 57{phone}.</p>
        <div>
          <textarea
            placeholder='Escribe aquí tu mensaje... (max. 159 caracteres)'
            maxLength={159}
            style= {{
              fontSize: 'smaller'
            }}
            name= {'personalMessage'}
            value= {personalMessage}
            onChange = {(e) => setPersonalMessage(e.target.value)}
            required
          /><br />
          {numFreeCredits === 1 && <button disabled className='btn btn-primary'>Enviar a mi celular</button>}
          {numFreeCredits === 2 && <button onClick={autoSend} className='btn btn-primary'>Enviar a mi celular</button>}
        </div>
        <br />
        <div>
          <p>El siguiente mensaje de prueba se enviará al número de celular que usted ingrese.</p>
          <div >
            <div style={{display: 'inline-block'}}>
              <div className='divFreeMessage'  style={{width: '100%'}}>
                {message}
              </div>
            </div>
            <br />
            57 &nbsp;<input style={{width: '150px', color: '#1f0e83', marginBottom:'5px', fontSize: 'smaller'}} type={'number'}
            value= {anotherPhone}
              placeholder= 'Celular 310123...'
              max={3999999999}
              onChange= {(e)=> setAnotherPhone(e.target.value)}
            />
            <br />
            {numFreeCredits === 2 && <button disabled className='btn btn-primary'>Enviar</button>}
            {numFreeCredits === 1 && <button onClick={NoAutoSend} className='btn btn-primary'>Enviar</button>}
          </div>

        </div>
        
    </div>
  )
}

export default FreeMessage
